import React, {Component} from 'react';

class FullFooter extends Component {
  render() {
    const year = new Date().getFullYear();

    return (
      <footer className="app-footer">
        <span>copyright &copy; {year} <a href="https://esid.org/">ESID</a>.<br />
        database from: {this.props.lastUpdated}
        </span>
        {/*<span className="ml-auto">Powered by <a href="https://cci-generic.uniklinik-freiburg.de">FORMED</a></span>*/}
      </footer>
    )
  }
}

export default FullFooter;



// WEBPACK FOOTER //
// ./src/containers/Full/FullFooter.js